module.exports = __webpack_public_path__ + "static/media/02.c2dc4580.jpg";